import { memo } from "react";

import { useApplicationNotifications } from "../use-application-notifications";

export const NotificationsPanelTitle = memo(() => {
  const { totalCount } = useApplicationNotifications();

  return (
    <h2 className="heading-h4 text-type-common">
      Уведомления <span className="text-type-light">({totalCount})</span>
    </h2>
  );
});

NotificationsPanelTitle.displayName = "NotificationsPanelTitle";
